<template>
  <div class="work_experience">
    <div class="tabs">
      <span></span>工作经验 <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
        <i v-show="isEdit" class="tabs_one" @click="goEssentialInformation"></i>
      </el-tooltip>

    </div>
    <el-form :inline="true" :label-position="labelPosition" label-width="100px" ref="ruleFormDataOne"
      :model="FormDataOne">
      <div class="work_experience_wrap" v-for="(domain, index) in FormDataOne.work_experience" :key="index">
        <el-form-item label="工作单位" :prop="'work_experience.' + index + '.companyName'" :rules="{
            required: true, message: '请输入工作单位名称', trigger: 'blur'
            }">
          <el-input v-model="domain.companyName" maxlength="30" :disabled="isDis" placeholder="请输入工作单位"></el-input>
        </el-form-item>

        <el-form-item label="职位" :prop="'work_experience.' + index + '.position'" :rules="{
         required: true, message: '请输入职位名称', trigger: 'blur'
         }" class="position">
          <el-input v-model="domain.position" maxlength="30" :disabled="isDis" placeholder="请输入职位"></el-input>
        </el-form-item>
        <el-form-item label="工作时间" :prop="'work_experience.' + index + '.work_time'" :rules="{
           required: true, message: '请选择工作时间', trigger: 'blur'
         }" class="work_time">
          <el-date-picker v-model="domain.work_time" type="daterange" :disabled="isDis" :unlink-panels="true"
            range-separator="至" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
      </div>
    </el-form>
    <!-- <div v-show="isAddWorkExperience" class="add_work_experience" @click="addWorkExperience"><i></i><span>添加工作经历</span>
    </div> -->
    <div class="btn" v-if="!isDis">
      <el-button class="cancel" @click="cancel">取消</el-button>
      <el-button class="preservation" @click="preservation('ruleFormDataOne')">保存</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userInfo: {
      type: Object
    }
  },

  watch: {
    userInfo: {
      handler (newVale, oldVale) {
        if (newVale.num === 1) {
          this.id = newVale.id
          this.auditStatus = newVale.auditStatus
          this.certificateUrls = newVale.certificateUrls
          if (newVale.workList !== null) {
            if (newVale.workList.length !== 0) {
              console.log(newVale.work_experience, '++++++++++++++++++++++++++')
              this.FormDataOne.work_experience = newVale.work_experience

            }

          }
          if (!this.dataObj) {
            this.dataObj = JSON.parse(JSON.stringify(this.FormDataOne))
          }
          // this.dataObj = { ...this.FormDataOne } // 解构对象，取消操作用解构对象

        }
      },
      deep: true,
      immediate: true
    },
  },
  computed: {
    isAddWorkExperience () {
      if (!this.isDis) {
        return this.FormDataOne.work_experience.length >= 3 ? false : true
      } else {
        return false
      }
    },
    isEdit () {
      if (this.auditStatus === 1) {
        return false
      } else {
        return this.isDis
      }
    },
  },
  data () {
    return {
      auditStatus: null,
      FormDataOne: {
        work_experience: [
          {
            companyName: "",
            position: "",
            work_time: [],
          }
        ],

      },
      dataObj: "",

      labelPosition: "left",
      isDis: true,
      flag: true,// 只执行一次
      id: null,
    };
  },

  methods: {
    goEssentialInformation () {
      this.isDis = false
    },
    //添加节点
    addWorkExperience () {
      this.FormDataOne.work_experience.push({ companyName: "", position: "", work_time: [], });

    },
    preservation (ruleFormDataOne) {
      let _this = this
      this.$refs[ruleFormDataOne].validate(async (valid) => {
        if (valid) {
          let url = "/v1/userRegister/add_or_update_register_info"
          let myUser = JSON.parse(localStorage.getItem("myUser"))
          let workList = JSON.parse(JSON.stringify(_this.FormDataOne.work_experience))// [..._this.FormDataOne.work_experience]
          workList.forEach(item => {
            item.workStartTime = item.work_time[0]
            item.workEndTime = item.work_time[1]
            delete item.work_time
          })
          let params = {
            id: this.id,
            auditStatus: this.auditStatus === 0 ? 0 : 2,
            userId: myUser.id,
            workList,
            certificateUrls: this.certificateUrls
          }

          const res = await this.catReq1Service(url, params)
          if (res.resultCode === "1") {
            this.isDis = true;
            _this.dataObj = JSON.parse(JSON.stringify(_this.FormDataOne))

            this.$emit("succe", res.result)
          }

        } else {

          return false;
        }
      });


    },
    cancel () {

      // let length = this.dataObj.work_experience.length
      // switch (length) {
      //   case 1:
      //     this.FormDataOne.work_experience.splice(1, 2)
      //     break;
      //   case 2:
      //     this.FormDataOne.work_experience.splice(2, 1)
      //     break;
      //   default:
      //     break;
      // }
      // this.FormDataOne = { ...this.dataObj }

      console.log(this.dataObj)

      this.FormDataOne = JSON.parse(JSON.stringify(this.dataObj))
      // this.$refs["ruleFormDataOne"].resetFields();
      this.$refs['ruleFormDataOne'].clearValidate();
      this.isDis = true;

    },
  },
};
</script>

<style lang="less" scoped>
.work_experience {
  .tabs {
    display: flex;
    font-size: 16px;
    align-items: center;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: rgba(28, 28, 29, 1);
    margin-bottom: 20px;
    span {
      width: 4px;
      height: 16px;
      background: rgba(30, 134, 230, 1);
      margin-right: 5px;
    }
    .tabs_one {
      display: inline-block;
      cursor: pointer;
      width: 16px;
      height: 16px;
      background: url("../../assets/imgs/authentication/modify_normal.png")
        no-repeat;
      background-size: cover;
      margin-left: 5px;
      &:active {
        background: url("../../assets/imgs/authentication/modify_press.png")
          no-repeat;
      }
    }
  }
  /deep/.el-form {
    .work_experience_wrap {
      margin-bottom: 10px;
      .el-input {
        width: 202px;
      }
      .el-form-item {
        width: 40%;
        text-align: left;
        &.work_time {
          // position: relative;
          // left: -145px;
          width: 53%;
        }
        &.position {
          position: relative;
          left: 55px;
        }
      }
    }
    display: flex;
    flex-wrap: wrap; //flex-grow
  }
  .add_work_experience {
    display: flex;
    cursor: pointer;
    float: left;
    margin-left: 10px;
    i {
      display: inline-block;
      vertical-align: middle;
      width: 20px;
      height: 20px;
      background: url("../../assets/imgs/editor/add_to_normal.png") no-repeat;
      background-size: cover;
    }
    span {
      display: inline-block;
      line-height: 20px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      margin-left: 5px;
    }
  }
  .btn {
    width: 100%;
    text-align: right;
    .el-button {
      width: 80px;
      height: 36px;
      box-sizing: border-box;
      font-family: Microsoft YaHei;
      font-size: 16px;
      line-height: 0;
    }
    .cancel {
      background: rgba(219, 239, 255, 1);
      border: 1px solid rgba(30, 134, 230, 1);
      box-shadow: 0px 3px 8px 0px rgba(153, 153, 153, 0.5);
      border-radius: 4px;
    }
    .preservation {
      background: rgba(30, 134, 230, 1);
      box-shadow: 0px 3px 8px 0px rgba(30, 134, 230, 0.5);
      border-radius: 4px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      margin-left: 50px;
    }
  }
}
</style>
